var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1667 3.24544V4.98711C17.1667 5.62044 16.7501 6.41211 16.3334 6.80794L12.7501 9.81628C12.2501 10.2121 11.9167 11.0038 11.9167 11.6371V15.0413C11.9167 15.5163 11.5834 16.1496 11.1667 16.3871L10.0001 17.0996C8.91673 17.7329 7.41673 17.0204 7.41673 15.7538V11.5579C7.41673 11.0038 7.0834 10.2913 6.75007 9.89544L6.3584 9.50753C6.10007 9.24628 6.05007 8.85044 6.2584 8.54169L10.5251 2.03419C10.6751 1.80461 10.9417 1.66211 11.2334 1.66211H15.5001C16.4167 1.66211 17.1667 2.37461 17.1667 3.24544Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62467 2.87336L5.66634 7.37794C5.38301 7.81336 4.73301 7.87669 4.35801 7.50461L3.58301 6.72878C3.16634 6.33294 2.83301 5.62044 2.83301 5.14544V3.32461C2.83301 2.37461 3.58301 1.66211 4.49967 1.66211H7.91634C8.56634 1.66211 8.96634 2.34294 8.62467 2.87336Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.84ce88d19fd2cbc4a38574a5a83fb5cf.svg";
export { ForwardRef as ReactComponent };